import { Model } from './Model';
import { defineApi } from './defineApi';
import { defineRepository } from './defineRepository';
import { defineController } from './defineController';
import { ApiResponse, PaginatedResponse, SimpleResponse, type IPagination } from './ApiResponse';
import { defineConfig } from './defineConfig';
import { createInstance } from './utils/createInstance';

export {
  createInstance,
  defineConfig,
  defineApi,
  defineRepository,
  defineController,
  Model,
  ApiResponse,
  PaginatedResponse,
  SimpleResponse,
  IPagination,
};
